import { getReferrerOverride } from './referrerOverride';

const getReferralUrl = (useReferrerOverride = false) => {
  if (!useReferrerOverride) return document.referrer;
  return getReferrerOverride() ?? document.referrer;
};

export default getReferralUrl;
